
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saas-platforms",
      function () {
        return require("private-next-pages/saas-platforms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saas-platforms"])
      });
    }
  